import {Stack} from '@mui/material'

import {OptimizerConstraintsButton} from '../optimizerConstraints/OptimizerConstraintsButton'
import {OptimizerSettingsButton} from '../optimizerSettings/OptimizerSettingsButton'

import {SendToOptimizedPlanButton} from './SendToOptimizedPlanButton'

export const PageOptimizerActions = () => {
  return (
    <Stack direction="row" spacing={1.5}>
      <OptimizerSettingsButton />
      <OptimizerConstraintsButton />
      <SendToOptimizedPlanButton />
    </Stack>
  )
}
